import axios from 'axios';
import { VerifyAuth } from './axiosInterceptor';

const API = process.env.REACT_APP_API_PATH;



export const getDashboardTicketStatus = async (companyId, fromDate, toDate, token) => {
  try {

    return await axios
      .get(`${API}/getDashboardTicketStatus/${companyId || 'null'}/${fromDate}/${toDate}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const getDashboardPriority = async (date, token) => {
  try {

    return await axios
      .get(`${API}/getDashboardPriority/${date}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const getDashboard_TicketStatus_Weekly_by_month = async (year, month, companyId, token) => {
  try {

    return await axios
      .get(`${API}/getDashboard_TicketStatus_Weekly_by_month/${year}/${month}/${companyId || 'null'}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};



export const getDashboard_supportServicesTable_Line = async (data, token) => {
  try {

    return await axios
      .post(`${API}/getDashboard_supportServicesTable_Line`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        console.log('chamindures', res.data)
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const getDashboard_supportServicesSummary = async (data, token) => {
  try {

    return await axios
      .post(`${API}/getDashboard_supportServicesSummary`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const getDashboard_TimeTracking_By_Resolver = async (fromDate, toDate, companyId, token) => {
  try {
    return await axios
      .post(`${API}/getDashboard_TimeTracking_By_Resolver`, { fromDate, toDate, companyId }, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const getDashboard_TimeTracking_By_Initiator = async (fromDate, toDate, companyId, token) => {
  try {
    return await axios
      .post(`${API}/getDashboard_TimeTracking_By_Initiator`, { fromDate, toDate, companyId }, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const getDashboard_PendingByAssignee = async (companyId, token) => {
  try {
    return await axios
      .get(`${API}/getDashboard_PendingByAssignee`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
        params: { companyId: companyId || 'null' },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};
